import React from "react"
import autobind from "class-autobind"
import _ from "lodash"
import GigPoolTierSettings from "./GigPoolTierSettings"
import { IGigPoolTierSettings } from "../../../models"
import { Toggle } from "material-ui"
import strings from "../../../localization/strings"

interface IProps {
    gigPoolTierSettingsList: IGigPoolTierSettings[],
    updateGigPoolTierSettingsList(newSetting: IGigPoolTierSettings[]): void
    hideLimitBroadcastByProximityInMiles: boolean
    showShiftsToMobileUsers: boolean
    handleChangeShowShiftsToMobileUsers(showShiftsToMobileUsers: boolean): void
}
interface IState {
    gigPoolTierSettingsList: IGigPoolTierSettings[],
}

export default class GigPoolRules extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            gigPoolTierSettingsList: props.gigPoolTierSettingsList && props.gigPoolTierSettingsList.length > 0 ? props.gigPoolTierSettingsList : [
                {
                    Order: 0,
                    Enabled: false,
                    EmployeeStatusList: [],
                    BroadcastOnSchedulePost: true,
                    EnabledScheduledBroadcast: false,
                    BraodcastAfterDaysFromPreviousTeir: 1,
                    BraodcastAfterHoursFromPreviousTeir: 0,
                    BroadcastOnlyIfWorkerPoolIsEmpty: true
                } as IGigPoolTierSettings,
                {
                    Order: 1,
                    Enabled: false,
                    EmployeeStatusList: [],
                    EnabledScheduledBroadcast: false,
                    BraodcastAfterDaysFromPreviousTeir: 1,
                    BraodcastAfterHoursFromPreviousTeir: 0,
                    BroadcastOnlyIfWorkerPoolIsEmpty: true
                } as IGigPoolTierSettings,
                {
                    Order: 2,
                    Enabled: false,
                    EmployeeStatusList: [],
                    EnabledScheduledBroadcast: false,
                    BraodcastAfterDaysFromPreviousTeir: 1,
                    BraodcastAfterHoursFromPreviousTeir: 0,
                    BroadcastOnlyIfWorkerPoolIsEmpty: true
                } as IGigPoolTierSettings,
            ],
            /*
            shift: props.shift ? props.shift : {
                
            }  as IScheduleShift
            */
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <Toggle
                    data-intercom-target={"Shift-AddShift-Toggle-ShowShiftsToMobileUser"}
                    label={strings.Advertise_Shift_To_Mobile_Users}
                    style={{ width: 300, marginTop: 15, marginBottom: 15 }}
                    toggled={this.props.showShiftsToMobileUsers}
                    onToggle={(e, value) => this.props.handleChangeShowShiftsToMobileUsers(value)}
                />
                {this.props.showShiftsToMobileUsers &&
                    <div>
                        <GigPoolTierSettings
                            title="Tier 1"
                            gigPoolTierSettings={this.state.gigPoolTierSettingsList[0]}
                            updateGigPoolTierSetting={(newSetting) => {
                                this.state.gigPoolTierSettingsList[0] = newSetting
                                this.props.updateGigPoolTierSettingsList(this.state.gigPoolTierSettingsList)
                            }}
                            hideLimitBroadcastByProximityInMiles={this.props.hideLimitBroadcastByProximityInMiles}
                        />

                        <GigPoolTierSettings
                            title="Tier 2"
                            gigPoolTierSettings={this.state.gigPoolTierSettingsList[1]}
                            updateGigPoolTierSetting={(newSetting) => {
                                this.state.gigPoolTierSettingsList[1] = newSetting
                                this.props.updateGigPoolTierSettingsList(this.state.gigPoolTierSettingsList)
                            }}
                            hideLimitBroadcastByProximityInMiles={this.props.hideLimitBroadcastByProximityInMiles}
                        />

                        <GigPoolTierSettings
                            title="Tier 3"
                            gigPoolTierSettings={this.state.gigPoolTierSettingsList[2]}
                            updateGigPoolTierSetting={(newSetting) => {
                                this.state.gigPoolTierSettingsList[2] = newSetting
                                this.props.updateGigPoolTierSettingsList(this.state.gigPoolTierSettingsList)
                            }}
                            hideLimitBroadcastByProximityInMiles={this.props.hideLimitBroadcastByProximityInMiles}
                        />
                    </div>
                }
            </div>
        )
    }
}
